import { render, staticRenderFns } from "./TableTagsCateBrand.vue?vue&type=template&id=4c5c3d23"
import script from "./TableTagsCateBrand.vue?vue&type=script&lang=js"
export * from "./TableTagsCateBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports